module.exports = __webpack_public_path__ + "static/cparta-67c018e4e55341da8147392f4b3b2c29.jpg";